import { memo } from "react";
import styles from './recovery.module.scss';
import ButtonShared from "../../../components/Button/Button";
import TextFieldShared from "../../../components/TextField/TextField";
import { RecoveryProps } from "../../../interfaces/app";

const Recovery = ({
    emailRecovery, 
    setEmailRecovery, 
    handlePress, 
    handleChange
}: RecoveryProps) => {

    return (
        <div className={styles.recoveryContent}>
            <p className={styles.description}>
                Indícanos tu cuenta de mail para enviarte un código y generar tu nueva clave
            </p>
            <div className={styles.content}>
                <div className={styles.inputs}>
                    <TextFieldShared
                        label="Email"
                        name="email"
                        value={emailRecovery?.value}
                        error={emailRecovery?.error}
                        onChange={(value: any) => setEmailRecovery({...emailRecovery, value: value})}
                        onEnter={handlePress}
                        autoFocus
                    />
                </div>
                <ButtonShared 
                    onPress={() => handleChange('login')}
                    title="Recordé mi clave" 
                    fontSize="small" 
                    className={styles.forgetPassword} 
                />
            </div>
        </div>
    )
}

export default memo(Recovery);